export const TOAST_KIND = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning',
} as const;

export type ToastKind = (typeof TOAST_KIND)[keyof typeof TOAST_KIND];

/** 종류별 기본 표시 시간(ms). 0 이면 스스로 닫히지 않는다 */
export const TOAST_DURATION_MS: Record<ToastKind, number> = {
  success: 3000,
  info: 3000,
  warning: 5000,
  error: 6000,
};

/** 한 번에 보이는 개수. 넘치면 오래된 것부터 닫는다 */
export const TOAST_MAX_VISIBLE = 3;
